module.exports = __webpack_public_path__ + "img/humanoid.921dfad6.svg";